import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ITileItemDrawerRequest {
  alias: string;
  itemId: string;
}

@Injectable({ providedIn: 'root' })
export class TileItemDrawerService {
  private static readonly aliasPattern = /^[a-zA-Z0-9_-]+$/;

  readonly openRequests$ = new Subject<ITileItemDrawerRequest>();

  open(request: ITileItemDrawerRequest): boolean {
    const normalized = this.normalize(request);
    if (!normalized) {
      return false;
    }

    this.openRequests$.next(normalized);
    return true;
  }

  private normalize(request: ITileItemDrawerRequest): ITileItemDrawerRequest | null {
    const alias = String(request?.alias ?? '').trim();
    const itemId = String(request?.itemId ?? '').trim();

    if (!alias || !itemId) {
      return null;
    }

    if (!TileItemDrawerService.aliasPattern.test(alias)) {
      return null;
    }

    if (alias.length > 128 || itemId.length > 256) {
      return null;
    }

    return { alias, itemId };
  }
}
